import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { PlycaUiPanelComponent } from '../panel.component';

@Component({
  selector: 'plyca-ui-panel-demo',
  templateUrl: './panel-demo.component.html',
  styleUrls: ['./panel-demo.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiPanelComponent]
})
export class PlycaUiPanelDemoComponent {}
